<template>
  <div>
    <form @submit.prevent>
      <div>
        <div class="row m-0 mb-3 justify-content-end">
          <div class="ml-2">
            <base-button
              button="Thêm mới"
              @click="moFormTao(isDetail = false)"
              class="btn search-information-btn d-block float-right"
            >
              THÊM MỚI
            </base-button>
          </div>
        </div>
      </div>
    </form>
    <div class="box-form-result">
      <p class="color-gray-1">Tìm thấy {{ totalRows }} kết quả</p>
      <DataTable :loading="isLoadingTable" :value="items">
        <Column
          field="id"
          dataKey="id"
          headerStyle="width: 40px"
          headerClass="p-2"
          header="STT"
          bodyStyle="text-align: center"
        >
          <template #filter> </template>
          <template #body="slotProps">
            <span>{{
              (requestInformation.pageIndex - 1) * requestInformation.pageSize +
              slotProps.index +
              1
            }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="name"
          :header="option.labelSearch"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestInformation.Name"
              @keyup.enter="timDanhSachVaiTro"
            />
          </template>
          <template #body="slotProps">
            <span class="cursor-pointer" @click="moFormTao(slotProps.data , isDetail = true)">{{ slotProps.data.name }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="appName"
          :header="requestInformation.Level == 2 ? 'Tỉnh thành' : 'Quận huyện'"
          headerStyle="minWidth: 200px"
          v-if="![0, 1].includes(requestInformation.Level)"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.ParentName"
              @keyup.enter="timDanhSachVaiTro"
            />
          </template>
          <template #body="slotProps">
            <div v-html="slotProps.data.parentName"></div>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="appName"
          header="Tỉnh thành"
          headerStyle="minWidth: 200px"
          v-if="requestInformation.Level == 3"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.ParentNameOfParent"
              @keyup.enter="timDanhSachVaiTro"
            />
          </template>
          <template #body="slotProps">
            <div v-html="slotProps.data.parentNameOfParent"></div>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="appName"
          header="Mã vị trí"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.CodeName"
              @keyup.enter="timDanhSachVaiTro"
            />
          </template>
          <template #body="slotProps">
            <div v-html="slotProps.data.codeName"></div>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="thaoTac"
          header="Thao tác"
          headerStyle="width: 100px"
        >
          <template #body="slotProps">
            <div class="text-center">
              <font-awesome-icon
                icon="edit"
                @click="moFormTao(slotProps.data , isDetail = false)"
                v-b-popover.hover.top="'Sửa'"
                class="cursor-pointer color-red"
              />
              <font-awesome-icon
                icon="trash-alt"
                v-b-popover.hover.top="'Xóa'"
                class="cursor-pointer color-red ml-2"
                @click="moFormXoaVaiTro(slotProps.data)"
              />
            </div>
          </template>
        </Column>
        <template #empty
          ><div class="text-center">Không có dữ liệu</div></template
        >
        <template #loading
          ><div class="text-center">Đang tải dữ liệu ...</div>
        </template>
      </DataTable>
    </div>
    <BasePagination
      class="mt-3"
      :current-page="requestInformation.pageIndex"
      :total-pages="totalPages"
      :total-rows="totalRows"
      @changeNum="onChangeNum($event)"
      @changePages="onChangePages($event)"
    />
    <ModalConfirm :title="vaiTroDaChon.name" @confirmed="xoaVaiTroThanhCong" />
    <modalSua
      ref="tao-tinh-thanh-modal"
      :title="option.title"
      :isEdit="isEdit"
      :isDetail="isDetail"
      :data="vaiTroDaChon"
      :id="reload"
      :type="option.labelSearch"
      :level="requestInformation.Level"
      :listParent="option.listParent"
      @refreshData="layDanhSachTinhThanh"
    />
  </div>
</template>

<script>
import BasePagination from "@/components/common/BasePagination";
import ModalConfirm from "@/components/modal/ModalConfirm";
import modalSua from "./modalSua";
import { BO_QUA_BUTTON_LABEL, ROUTE_NAME } from "@/constants/constants";
import { mapGetters } from "vuex";
import _isEmpty from "lodash/isEmpty";
import _isNil from "lodash/isNil";
import {
  LOCAL_STORAGE_KEY,
  setValueToStorageByKey,
} from "@/utils/localStorage";

export default {
  name: "DanhSachVaiTro",
  components: {
    BasePagination,
    ModalConfirm,
    modalSua,
  },
  data() {
    return {
      ROUTE_NAME: ROUTE_NAME,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      items: [],
      requestInformation: {
        sortType: "",
        Level: 1,
        pageSize: 10,
        pageIndex: 1,
        appId: null,
        sortBy: "ThuTu",
      },
      option: {
        labelSearch: "",
        listParent: [],
        title: "",
      },
      isEdit: false,
      isDetail: false,
      requestInternalForm: {},
      totalPages: 0,
      totalRows: 0,
      isLoadingTable: true,
      vaiTroDaChon: {},
      requestForm: {},
      reload: false,
    };
  },
  props: {
    isVung: {
      type: Boolean,
      default: false,
    },
    isTinhThanh: {
      type: Boolean,
      default: false,
    },
    isQuanHuyen: {
      type: Boolean,
      default: false,
    },
    isPhuongXa: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      danhSachApp: "app/tatCaApp",
      danhSachVaiTro: "dmTinhThanh/danhSachTinhThanh",
      appId: "common/appId",
    }),
    hasPageData() {
      return !_isEmpty(this.danhSachVaiTro.items);
    },
  },
  watch: {
    danhSachVaiTro: {
      handler() {
        this.totalPages = this.danhSachVaiTro.totalPage;
        this.totalRows = _isNil(this.danhSachVaiTro.totalCount)
          ? 0
          : this.danhSachVaiTro.totalCount;
        this.items = this.danhSachVaiTro.items;
      },
      immediate: true,
    },
    "requestInformation.pageIndex": {
      handler() {
        this.layDanhSachTinhThanh();
      },
    },
    "requestInformation.appId": {
      handler() {
        // this.timDanhSachVaiTro();
        setValueToStorageByKey(
          LOCAL_STORAGE_KEY.APP_ID,
          this.requestInformation.appId
        );
        this.$store.dispatch("common/setAppId", this.requestInformation.appId);
      },
      deep: true,
    },
  },
  created() {
    //is Vung`
    if (this.isVung) {
      this.option = {
        labelSearch: "Tên vùng",
        listParent: [],
        title: "vùng",
      };
      this.requestInformation.Level = 0;
    }
    if (this.isTinhThanh) {
      this.option = {
        labelSearch: "Tên tỉnh/ thành phố",
        listParent: [],
        title: "tỉnh thành phố",
      };
      this.requestInformation.Level = 1;
    }
    if (this.isQuanHuyen) {
      this.option = {
        labelSearch: "Tên quận/ huyện",
        listParent: [],
        title: "quận huyện",
      };
      this.requestInformation.Level = 2;
    }
    if (this.isPhuongXa) {
      this.option = {
        labelSearch: "Tên phường/ xã",
        listParent: [],
        title: "phường xã",
      };
      this.requestInformation.Level = 3;
    }
    this.layDanhSachTinhThanh();
  },
  methods: {
    themMoi() {
      this.$router.push({
        path: `${ROUTE_NAME.QUAN_TRI_HE_THONG.VAI_TRO}/tao-moi`,
        params: {
          laTaoMoi: true,
        },
      });
    },
    layDanhSachApp() {
      this.$store.dispatch("app/layTatCaApp");
    },
    async moFormTao(item = null, isDetail) {
      console.log('isDetail', isDetail);
      this.$refs["tao-tinh-thanh-modal"].showModal();
      let levelParent = this.requestInformation.Level - 1;
      if (levelParent == 2) levelParent = 1;
      if (item) {
        if(levelParent == 0) item.parentNameOfParent = null;
        this.vaiTroDaChon = item;
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      const payload = {
        Level: levelParent == 0 ? null : levelParent,
        PageIndex: 1,
        PageSize: 999,
        onSuccess: (data) => {
          this.option.listParent = data.items;
        },
      };
      this.reload = !this.reload;
      await this.$store.dispatch("dmTinhThanh/layDanhSachTinhThanh", payload);
    },
    hideModal() {
      this.$refs["tao-tinh-thanh-modal"].hide();
    },
    onChangeNum(pageSize) {
      this.requestInformation.pageIndex = 1;
      this.requestInformation.pageSize = pageSize;
      this.layDanhSachTinhThanh();
    },
    onChangePages(page) {
      this.requestInformation.pageIndex = page;
    },
    timDanhSachVaiTro(requestForm) {
      this.requestInformation.pageIndex = 1;
      this.requestInternalForm = requestForm;
      this.layDanhSachTinhThanh();
    },
    layDanhSachTinhThanh() {
      const payload = {
        ...this.requestInternalForm,
        ...this.requestInformation,
        ...this.requestForm,
      };
      this.isLoadingTable = true;
      this.$store
        .dispatch("dmTinhThanh/layDanhSachTinhThanh", payload)
        .then(() => {
          this.isLoadingTable = false;
        });
    },

    moFormXoaVaiTro(item) {
      this.vaiTroDaChon = item;
      this.$bvModal.show("modal-confirm");
    },
    xoaVaiTroThanhCong(confirm) {
      if (confirm) {
        const $vm = this;
        this.$bvModal.hide("modal-confirm");
        this.$store
          .dispatch("dmTinhThanh/xoaTinhThanh", {
            data: {
              id: this.vaiTroDaChon.id,
            },
          })
          .then(() => {
            $vm.$toasted.clear();
            $vm.$toasted.global.showSuccessMessage({
              message: `Xóa ${
                $vm.requestInformation.Level == 1
                  ? "tỉnh/ thành phố"
                  : $vm.requestInformation.Level == 2
                  ? "quận/ huyện"
                  : $vm.requestInformation.Level == 3
                  ? "phường/ xã"
                  : "vùng"
              } thành công`,
            });
            $vm.layDanhSachTinhThanh();
          });
      }
    },
  },
};
</script>
